import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-48998224")

_pushScopeId("data-v-48998224")
const _hoisted_1 = { class: "favorites-page" }
const _hoisted_2 = { class: "favorites-page-top-area" }
const _hoisted_3 = { class: "favorites-page-select-list-area" }
const _hoisted_4 = { class: "favorites-page-select-list-button-text-area" }
const _hoisted_5 = { class: "favorites-page-select-list-button-text-area" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "favorites-page-top-blur-area" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_HistoryList = _resolveComponent("HistoryList")
  const _component_PullToRefresh = _resolveComponent("PullToRefresh")
  const _component_MyList = _resolveComponent("MyList")
  const _component_FavoritesFolderNameInputDialog = _resolveComponent("FavoritesFolderNameInputDialog")
  const _component_CommonOKDialog = _resolveComponent("CommonOKDialog")
  const _component_CommonDialog = _resolveComponent("CommonDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectMylist())),
          class: "favorites-page-select-list-button"
        }, [
          _createVNode("div", _hoisted_4, [
            _createVNode("span", {
              class: "favorites-page-select-list-button-text",
              style: _ctx.styleTextColorSelectedMylist
            }, _toDisplayString(_ctx.mylistTitle), 5)
          ]),
          _createVNode("div", {
            class: "favorites-page-select-list-button-select-indicator",
            style: _ctx.styleOpacitySelectedMylist
          }, null, 4)
        ]),
        _createVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectHistories(...args))),
          class: "favorites-page-select-list-button"
        }, [
          _createVNode("div", _hoisted_5, [
            _createVNode("span", {
              class: "favorites-page-select-list-button-text",
              style: _ctx.styleTextColorSelectedHistories
            }, _toDisplayString(_ctx.historiesTitle), 5)
          ]),
          _createVNode("div", {
            class: "favorites-page-select-list-button-select-indicator",
            style: _ctx.styleOpacitySelectedHistories
          }, null, 4)
        ])
      ]),
      _hoisted_6
    ]),
    _createVNode("div", {
      class: "favorites-page-histories",
      style: _ctx.styleHistoriesArea
    }, [
      _createVNode(_component_PullToRefresh, {
        topMargin: 8.5,
        onRefresh: _ctx.refreshHistory
      }, {
        default: _withId(() => [
          _createVNode(_component_HistoryList, {
            key: _ctx.updateDisplayKey,
            sendedHistory: _ctx.sendedList,
            viewedHistory: _ctx.viewedList
          }, null, 8, ["sendedHistory", "viewedHistory"])
        ]),
        _: 1
      }, 8, ["topMargin", "onRefresh"])
    ], 4),
    _createVNode("div", {
      class: "favorites-page-mylist",
      style: _ctx.styleFavoritesArea
    }, [
      _createVNode(_component_PullToRefresh, {
        topMargin: 8.5,
        onRefresh: _ctx.refreshMyList
      }, {
        default: _withId(() => [
          _createVNode(_component_MyList, {
            key: _ctx.updateDisplayKey,
            recipeList: _ctx.recipeList,
            folderList: _ctx.folderList,
            onAppendFolder: _ctx.appendFolderRequest,
            onMoveFolder: _ctx.moveFolder
          }, null, 8, ["recipeList", "folderList", "onAppendFolder", "onMoveFolder"])
        ]),
        _: 1
      }, 8, ["topMargin", "onRefresh"])
    ], 4),
    _createVNode(_component_FavoritesFolderNameInputDialog, {
      showDialog: _ctx.showAppendFolderDialog,
      key: _ctx.updateInputFolderNameKey,
      onCloseClick: _ctx.closeAppendFolderDialog,
      onAppendClick: _ctx.appendFolder
    }, null, 8, ["showDialog", "onCloseClick", "onAppendClick"]),
    _createVNode(_component_CommonOKDialog, {
      showDialog: _ctx.showOKDialog,
      message: _ctx.okDialogMessage,
      onOkClick: _ctx.okDialogHandler
    }, null, 8, ["showDialog", "message", "onOkClick"]),
    _createVNode(_component_CommonDialog, {
      showDialog: _ctx.showApiErrorDialog,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      onNegativeClick: _ctx.cancelHandler,
      onPositiveClick: _ctx.retryHandler
    }, null, 8, ["showDialog", "title", "message", "onNegativeClick", "onPositiveClick"])
  ]))
})